function PhoneFormat (value) {
    return value.length >= 9;
}

export default PhoneFormat
